<template>
  <div
    class="bg-image h-100 position-relative overflow-hidden"
    :style="{
      backgroundImage: `url(${backgroundSrc})`,
      backgroundColor: backgroundColor
    }"
    :class="`${backgroundClass}`"
  >
    <div class="container text-start overflow-auto">
      <div class="row py-5">
        <div
          class="mb-3 mb-lg-0"
          :class="{
            col: useInstructions,
            'col-12 col-md-6 offset-md-1': !useInstructions
          }"
        >
          <div class="card bg-dark text-light bg-opacity-90 mb-3">
            <div class="card-body p-4">
              <h1 class="card-title">{{ appTitle }}</h1>
              <!-- Main Content -->
              <div>
                <p class="card-subtitle h5 mb-3">
                  This is a good place to add a short paragraph or 2 describing
                  the activity.
                </p>
                <p>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                  do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                  Ut enim ad minim veniam, quis nostrud exercitation ullamco
                  laboris nisi ut aliquip ex ea commodo consequat.
                </p>
              </div>
              <!-- Activity page link, default set to route Main -->
              <div class="text-end">
                <routerLink
                  class="btn btn-lg btn-primary"
                  :to="{ name: callToActionTextDestination }"
                >
                  {{ callToActionText }}
                </routerLink>
              </div>
            </div>
          </div>
          <div v-if="useControls" class="card bg-dark text-light bg-opacity-90">
            <div class="card-body p-4">
              <UserControls />
            </div>
          </div>
        </div>
        <div v-if="useInstructions" class="col">
          <div class="card bg-dark text-light bg-opacity-90">
            <div class="card-body p-4">
              <UserInstructions />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import UserInstructions from "@/components/ui/UserInstructions.vue";
import UserControls from "@/components/ui/UserControls.vue";
import config from "@/data/config.json";

export default {
  name: "LandingView",
  components: { UserInstructions, UserControls },
  data() {
    return {
      appTitle: config.meta.title,
      // From within the @/assets folder
      // Be aware of file size: Max Size 512kb
      backgroundImg: config.landingView.backgroundImg,
      backgroundAlt: config.landingView.backgroundAlt,
      backgroundColor: config.landingView.backgroundColor,
      backgroundClass: config.landingView.backgroundClass,
      callToActionText: config.landingView.callToActionText,
      callToActionTextDestination:
        config.landingView.callToActionTextDestination,
      useInstructions: config.landingView.useInstructions,
      useControls: config.landingView.useControls
    };
  },
  computed: {
    backgroundSrc() {
      if (!this.useBackgroundImg) {
        return;
      }

      return require(`@/assets/${this.backgroundImg}`);
    },
    useBackgroundImg() {
      return this.backgroundImg !== "";
    }
  }
};
</script>
<style scoped>
.bg-image {
  background-size: contain;
  background-position: center bottom;
  background-repeat: no-repeat;
}
.bg-opacity-90 {
  --bs-bg-opacity: 0.9;
}
</style>
